import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

export const useLoginForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get("redirect");

  const [showPassword1, setShowPassword1] = useState(false);

  const handleTogglePasswordVisibility1 = () => {
    setShowPassword1((prev) => !prev);
  };

  const onSubmit = async (data) => {
    try {
      const response = await postApi(apiEndPoints.devoteeLogin, data);
      if (response?.data?.status === 1) {
        localStorage.setItem("devoteeData", JSON.stringify(response.data.data));
        toast.success(response?.data?.message);
        navigate(redirect);
      } else {
        toast.error(
          "Please use valid credentials or reset password using Forget Password"
        );
      }
    } catch (error) {
      toast.error(
        "Please use valid credentials or reset password using Forget Password"
      );
    }
  };

  return {
    onSubmit,
    showPassword1,
    handleTogglePasswordVisibility1,
  };
};